export default "__VITE_ASSET__B3sN28GO__"